export default {
  title: 'Akceptacja wniosku',
  type: 'object',
  properties: {
    teamIds: {
      title: 'Grupy treningowe',
      type: 'array',
      items: {
        type: 'integer'
      },
      fieldRequired: true,
      minItems: 1
    }
  }
};
